import { useEffect, useState } from "react";
import PortfolioList from "../portfolioList/PortfolioList";
import "./portfolio.scss";
import {
  featuredPortfolio,
  webPortfolio,
  mobilePortfolio,
  designPortfolio,
  contentPortfolio,
} from "../../data";
// import ProjectModal from "../modal/ProjectModal";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { BackspaceRounded } from "@material-ui/icons";

const style = {

  // position: 'absolute',
  // top: '50%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  // width: 600,
  // bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  // p: 4,



};

const myButtonDiv = {
  // background: "red",
  textAlign: 'center',
  display: "flex",
  // justifyContent: "space-between",
  justifyContent: "right",


  '& a': {
    color: "pink"
  }

}
const myButtons = {
  color: "white",
  background: "crimson",
  width: "4rem",
  height: "2rem",
  borderRadius: "01.5rem",
  margin: "0.5rem",
  cursor: "pointer"

}



export default function Portfolio() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);
  const list = [
    {
      id: "featured",
      title: "Featured",
    },
    {
      id: "web",
      title: "Web App",
    },
    {
      id: "mobile",
      title: "Mobile App",
    },
    {
      id: "design",
      title: "Design",
    },
    {
      id: "content",
      title: "Content",
    },
  ];

  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredPortfolio);
        break;
      case "web":
        setData(webPortfolio);
        break;
      case "mobile":
        setData(mobilePortfolio);
        break;
      case "design":
        setData(designPortfolio);
        break;
      case "content":
        setData(contentPortfolio);
        break;
      default:
        setData(featuredPortfolio);
    }
  }, [selected]);

  // const [isCalled, setIsCalled] = useState(false)

  // const alertIt = () => {
  //   setIsCalled(true)
  // }
  const [isTrue, setIsTrue] = useState(false)
  const [crrData, setCrrData] = useState({})

  const handleModal = (g) => {

    setCrrData(g)
  }



  return (

    <div className="portfolio" id="projects">

      <h1 style={{
        fontSize: "2.6rem", overflow: "hidden",
        marginBottom: "1rem", marginTop: "1rem"
      }}>Projects</h1>

      <div className="container">
        {
          data.map((d) => {

            return <div>
              <div div className="item"
              // onClick={() => alertIt()}
              >

                <img
                  src={d.img}
                  alt=""
                  onClick={
                    () => {
                      handleOpen()
                      handleModal(d)
                    }
                  }
                />
                <h3>
                  <h5 >click for details</h5>
                </h3>
                {/* <ProjectModal title={d.title} setIsTrue={setIsTrue} /> */}
              </div>

              <div className="projectModalDiv">
                {/* <Button onClick={handleOpen}>Open modal</Button> */}
                <Modal className="projectModal"
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style} className="projectBox">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      <h3 style={{ fontSize: "2rem" }}> {crrData.title}</h3>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      <div className="imageInModal">
                        <img src={crrData.img}
                          style={{
                            width: "100%",
                            // width: "30rem",
                            height: "auto"

                          }} id="projectImage" alt=""
                        />

                        <p>
                          {crrData.description}
                        </p>
                        <p>
                          <h3>Tech Stacks</h3>
                          {/* {crrData.techStack} */}
                        </p>
                        <img src={crrData.techStackImage}></img>
                      </div>

                      <div className="myButton" style={myButtonDiv}>

                        <a href={crrData.preview} target="_blank"><button style={myButtons}>Preview</button></a>
                        <a href={crrData.link} target="_blank"><button style={myButtons}>Code</button></a>
                        <a href={crrData.BlogUrl} target="_blank"><button style={myButtons}>Blog</button></a>

                      </div>

                    </Typography>
                  </Box>
                </Modal>
              </div>


            </div>
          }
          )

        }
      </div>

    </div>
  )


};